module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1100.cfaa14d8.svg";